import { createApp } from 'vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import App from './App.vue'
import router from './router'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(faUserSecret)

const firebaseConfig = {
  apiKey: "AIzaSyAIK-Jua_EYmENc-H6CVEQ_mjhKgIATK08",
  authDomain: "zeropointmathematics.firebaseapp.com",
  projectId: "zeropointmathematics",
  storageBucket: "zeropointmathematics.firebasestorage.app",
  messagingSenderId: "714887510138",
  appId: "1:714887510138:web:71d2f8722e1343a9f563c3"
};

firebase.initializeApp(firebaseConfig);

let app;

firebase.auth().onAuthStateChanged(user => {
  if(!app) {
    console.log(user?.email.replace(user?.email, 'Hello there!'));
    
    app = createApp(App)
            .component('font-awesome-icon', FontAwesomeIcon)
            .use(router)
            .mount('#app');
  }
});